<script lang="ts">
    import {type Meeting } from './src/types';
    import {onMount} from 'svelte';    
    import { season, team } from './store'
    import Fa from 'svelte-fa/src/fa.svelte';
    import { faTrash, faEye, faTrophy } from '@fortawesome/free-solid-svg-icons/index.js';
    

    export let meeting:Meeting;

    export let deleteMeeting: () => void;

    export let guest : boolean = false;

    export let final_score : {team:number;opponent:number} = {
        team:0,
        opponent:0
    };

    export let displaySheet : (id: number) => void  = (id:number) => {};

    

    onMount(async() => {       
    })

    
    const getMatchColor = ():string => {        
        if (final_score.team > final_score.opponent ) {
            return "green";
        }
        else if (final_score.opponent > final_score.team) {
            return "red";
        }
        return "orange";
    }

</script>

<div style="display:flex;flex-direction: column; margin-right: 25px;">
    <div style="display:flex; flex-direction:row">
<h2 style="color:{getMatchColor()}" on:click={(e) => {e.preventDefault(); displaySheet(meeting.sheetId);}}>{meeting.date} - {meeting.team}
{#if meeting && meeting.coupe}
    <Fa icon="{faTrophy}" size="2x"/>
{/if}
</h2>

{#if !guest} 
<a href='#/team/{$team}/{$season}' on:click={deleteMeeting}><Fa icon="{faTrash}" size="3x"/></a>
{/if}
</div>
<table on:click={(e) => {e.preventDefault(); displaySheet(meeting.sheetId);}}>
{#if meeting.atHome}
    <tr><td colspan="3" style="font-weight:bold">{$team}</td><td colspan="3" style="font-weight:bold">{meeting.team}</td></tr>
{:else}
    <tr><td colspan="3" style="font-weight:bold">{meeting.team}</td><td colspan="3" style="font-weight:bold">{$team}</td></tr>
{/if}
{#each meeting.matches as match}	
    {#if meeting.atHome}
    <tr>
        <td>{match.score.me > match.score.other ? (match.double  && match.coupe ? '2' : '1') : '0'}</td>              
        <td>{match.name}</td><td>{match.score.me}</td>
        <td>{match.score.other}</td><td>{match.opponent} {!match.double ? "("+match.otherRanking+")" : ""}</td>              
        <td>{match.score.me > match.score.other ? '0' : (match.double && match.coupe ? '2' : '1')}</td>    
    </tr>
    {:else}
    <tr>
        <td>{match.score.me > match.score.other ? '0' : (match.double  && match.coupe ? '2' : '1') }</td>              
        <td>{match.opponent} {!match.double ? "("+match.otherRanking+")" : ""}</td><td>{match.score.other}</td>
        <td>{match.score.me}</td><td>{match.name}</td>              
        <td>{match.score.me > match.score.other ? (match.double && match.coupe ? '2' : '1') : '0'}</td>    
    </tr>
    {/if}
{/each}
{#if meeting.atHome}
<tr><td style="border-top: thick solid white;">{final_score.team}</td><td colspan="4">&nbsp;</td><td style="border-top: thick solid white;">{final_score.opponent}</td></tr>
{:else}
<tr><td style="border-top: thick solid white;">{final_score.opponent}</td><td colspan="4">&nbsp;</td><td style="border-top: thick solid white;">{final_score.team}</td></tr>
{/if}
</table>
</div>